import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import UsuarioService from '../../services/usuario_service.js';
import SedeService from '../../services/sede_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const usuarioService = new UsuarioService();
const sedeService = new SedeService();

let _this;
export default {
	name: 'Usuario',	
	data: function() {
		return {
			titulo: 'Usuario',
			data: {activoUsuario: 1, rol: 1, idsSedeFacturacion: []},
			validaciones: {},
			loginService: loginService,
			submited: false,
			roles: [],
			sedes: []
		} 
	}, 
	created: function () {
		_this = this;
		this.submited = false;
		_this = this;
		this.getData();
		this.getRoles();
		this.getSedes();
	}, 
	methods: { 
		getData: function() {
			if(routeService.getParams().id != undefined) {
				if(!loginService.esAdministrador()) {
					routeService.goToHome();
					return;
				}
				this.data.idUser = routeService.getParams().id;
				usuarioService.get({idUser: this.data.idUser}).then(function(response) {
					_this.data = {};
					if(response.body == null) {
						alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert('danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let value of response.body) {
							_this.data = {
								idUser: value.idUser,
								name: value.name,
								lastName: value.lastName,
								dni: value.dni,
								uName: value.uName,
								emailUser: value.emailUser,							
								activoUser: value.activoUser == 1 ? 'SI' : 'NO',
								rol: value.rol,
								idsSedeFacturacion: []
							}; 
							_this.getUserRoles();
							_this.getUserSedes();
						} 
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error);
					return;
				});
			} else {
				if(!loginService.esAdministrador()) {
					routeService.goToHome();
					return;
				}
			}
		},
		getRoles: function() {
			usuarioService.getRoles({}).then(function(response) {
				_this.roles = [];
				if(response.body == null) {
					alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert('danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					_this.roles = response.body;
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error);
				return;
			});
		},
		getUserRoles: function() {
			usuarioService.getUserRoles({idUser: _this.data.idUser}).then(function(response) {
				if(response.body == null) {
					alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert('danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					_this.data.rol = response.body[0].idRol;
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error);
				return;
			});
		},
		getUserSedes: function() {
			_this.data.idsSedeFacturacion = [];
			usuarioService.getUserSedes({idUser: _this.data.idUser}).then(function(response) {
				if(response.body == null) {
					alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert('danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.data.idsSedeFacturacion.push(value.idSede);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error);
				return;
			});
		},
		getSedes: function() {
			_this.sedes = [];
			sedeService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.sedes.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		save: function() {
			let errores = this.validar();
			if (errores) {
				alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'No se completaron correctamente los datos.\nVerifique los errores en el formulario.');
				return;
			}
			let data = {
				idUser: this.data.idUser,
				name: this.data.name,
				lastName: this.data.lastName,
				dni: this.data.dni,
				uName: this.data.uName,
				emailUser: this.data.emailUser,	
				uPassword: this.data.uPassword, 
				rol: this.data.rol, 							
				activoUser: this.data.activoUser == 1 ? 'SI' : 'NO',
				idsSedeFacturacion: this.data.idsSedeFacturacion 
				/*col1Tag: this.data.col1Tag,
				col2Tag: this.data.col2Tag,
				col3Tag: this.data.col3Tag,*/
			}; 
			this.submited = true;
			usuarioService.save(data).then(function(response) {
				if(response.body && response.body.status == 'success') {
					alertService.showSuccessToast('Datos guardados con exito.'); 
					routeService.goTo('usuarios'); 
				}
				_this.submited = false; 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error);
				return;
			});
		},
		validar: function() {
			let validaciones = {};
			let errores = false;
			if (typeof this.data.name == 'undefined' || this.data.name == '') {
				errores = true;
				validaciones['name'] = {errores: ['El nombre es obligatorio.'], estado: false};
			}
			if (typeof this.data.uName == 'undefined' || this.data.uName == '') {
				errores = true;
				validaciones['uName'] = {errores: ['El nombre de usuario es obligatorio.'], estado: false};
			}
			if (typeof this.data.emailUser == 'undefined' || this.data.emailUser == '') {
				errores = true;
				validaciones['emailUser'] = {errores: ['El email es obligatorio.'], estado: false};
			}
			if ((typeof this.data.uPassword == 'undefined' || this.data.uPassword == '') && (typeof this.data.idUser == 'undefined')) {
				errores = true;
				validaciones['uPassword'] = {errores: ['El password es obligatorio.'], estado: false};
			}
			if ((typeof this.data.rol == 'undefined' || this.data.rol == '') && (typeof this.data.rol == 'undefined')) {
				errores = true;
				validaciones['rol'] = {errores: ['El rol es obligatorio.'], estado: false};
			}
			this.validaciones = validaciones;
			return errores;
		},
		limpiarError: function (campo) {
			if (campo == undefined || campo.errores.length == 0) {
				return true;
			}
			campo.errores.length = 0;
			campo.estado = true;
		},
		cancelar: function() {
			routeService.goToBack();
		},
		seoName: function() {
			this.data.seoTag = generalService.toSeoUrl(this.data.descripcionTag);
			this.$forceUpdate();
		}
	}
}

